var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 19.8984C11.4037 19.8984 10.9203 19.415 10.9203 18.8187V4.97815C10.9203 4.38184 11.4037 3.89844 12 3.89844C12.5963 3.89844 13.0797 4.38184 13.0797 4.97815V18.8187C13.0797 19.415 12.5963 19.8984 12 19.8984ZM5.07425 12.9727C4.48096 12.9727 4 12.4917 4 11.8984C4 11.3051 4.48096 10.8242 5.07425 10.8242H18.9258C19.519 10.8242 20 11.3051 20 11.8984C20 12.4917 19.519 12.9727 18.9258 12.9727H5.07425Z",
    fill: "#898989"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddLight);
export default __webpack_public_path__ + "static/media/add_light.11c5a0d8f70e665bf8b0ddb14313b136.svg";
export { ForwardRef as ReactComponent };